import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: 'post-graduate-education-templates',
    name: 'postGraduateEducationTemplateData',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'postGraduateEducationTemplateList',
        component: () => import('../pages/PostGraduateEducationTemplateListPage.vue')
      },
      {
        path: ':postGraduateEducationTemplateId',
        name: 'postGraduateTemplateDetails',
        component: () => import('../pages/PostGraduateEducationTemplateDetailsPage.vue'),
        props: true,
        children: [
          {
            path: '',
            name: 'postGraduateTemplate',
            component: () => import('../containers/PostGraduateEducationTemplateDetails.vue'),
            props: true
          },
          {
            path: 'partial-exam',
            name: 'partExam',
            component: () => import('../containers/PartExamDetails.vue'),
            props: true
          }
        ]
      }
    ]
  }
];

export default routes;
